"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _brightDates = require("bright-dates");

var _reactGa = require("react-ga");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _Header = _interopRequireDefault(require("../Header"));

var _ItemSelector = _interopRequireDefault(require("../ItemSelector"));

var _Cancel = _interopRequireDefault(require("../Cancel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: 0 ", ";\n\tpadding: ", " 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Footer = _styledComponents.default.div(_templateObject(), _spacing.default.s3, _spacing.default.s2);

Footer.displayName = 'Footer';
var MONTHS = (0, _brightDates.monthsShort)();

var HeaderMonthPanel = function HeaderMonthPanel(props) {
  var year = props.year,
      yearRange = props.yearRange,
      month = props.month,
      setMonth = props.setMonth,
      setYear = props.setYear,
      switchBackToCalendarView = props.switchBackToCalendarView,
      onCancelClick = props.onCancelClick,
      _props$GA = props.GA,
      category = _props$GA.category,
      actionId = _props$GA.actionId,
      isViewingCurrentYear = props.isViewingCurrentYear,
      isMonthOnly = props.isMonthOnly;
  var showNext = year !== yearRange.max;
  var showPrevious = year !== yearRange.min;
  var defaultSelectedItem = MONTHS[month];
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Header.default, {
    onNext: function onNext() {
      setYear(year + 1);
    },
    onPrevious: function onPrevious() {
      setYear(year - 1);
    },
    showNext: showNext,
    showPrevious: showPrevious
  }, year.toString()), _react.default.createElement(_ItemSelector.default, {
    onItemSelected: function onItemSelected(selectedMonth) {
      var selectedIndex = MONTHS.indexOf(selectedMonth);
      setMonth(selectedIndex);
      switchBackToCalendarView();
      (0, _reactGa.event)({
        category: category,
        action: actionId + " - Month " + (selectedIndex + 1)
      });
    },
    selectedItem: defaultSelectedItem,
    hideSelected: !isViewingCurrentYear,
    items: MONTHS
  }), _react.default.createElement(Footer, null, !isMonthOnly && _react.default.createElement(_Cancel.default, {
    text: "Cancel",
    onClick: onCancelClick
  }, "Cancel")));
};

HeaderMonthPanel.displayName = 'HeaderMonthPanel';
HeaderMonthPanel.propTypes = {
  year: _propTypes.number.isRequired,
  month: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,
  yearRange: (0, _propTypes.shape)({
    min: _propTypes.number.isRequired,
    max: _propTypes.number.isRequired
  }).isRequired,
  setMonth: _propTypes.func.isRequired,
  setYear: _propTypes.func.isRequired,
  switchBackToCalendarView: _propTypes.func.isRequired,
  onCancelClick: _propTypes.func,
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    actionId: _propTypes.string
  }).isRequired,
  isViewingCurrentYear: _propTypes.bool,
  isMonthOnly: _propTypes.bool
};
HeaderMonthPanel.defaultProps = {
  onCancelClick: null,
  isViewingCurrentYear: true,
  isMonthOnly: false
};
var _default = HeaderMonthPanel;
exports.default = _default;